import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
import { debounce } from 'underscore';
import { setPrimaryTracker } from 'usage-tracker-container';
import { REPORTING_TRACKER } from 'reporting-data/constants/usageTracker';
const trackerInstance = createTracker({
  events
});
setPrimaryTracker(trackerInstance, REPORTING_TRACKER);
class UsageTracker {
  constructor() {
    this.tracker = createTracker({
      events
    });
    this.trackerAsBeacon = this.tracker.clone ? this.tracker.clone({}) : null;
  }
  getTracker() {
    return this.tracker;
  }
  isInitialized() {
    return !!this.getTracker();
  }
  cloneTracker(configOptions) {
    return this.tracker ? this.tracker.clone(configOptions) : null;
  }
  track(event, properties = {}) {
    if (this.tracker) {
      this.tracker.track(event, properties);
    } else if (!window.jasmine) {
      console.error('Cannot track usage before tracker initialization.');
    }
  }
  trackCreateInteraction(properties, isUsage = false) {
    const eventType = isUsage ? 'createUsage' : 'createInteraction';
    this.track(eventType, properties);
  }
  trackDetailsInteraction(properties, isUsage = false) {
    const eventType = isUsage ? 'detailsUsage' : 'detailsInteraction';
    this.track(eventType, properties);
  }
  trackDashboardInteraction(properties, isUsage = false) {
    const eventType = isUsage ? 'dashboardUsage' : 'dashboardInteraction';
    this.track(eventType, properties);
  }
  createDebouncedTracker(event, properties, debounceTime) {
    return debounce(() => this.track(event, properties), debounceTime);
  }

  // NOTE Functionally no different than track, but helps clarify which events are public
  // ********** PUBLIC EVENT **********
  // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
  // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
  // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
  trackPublicEvent(event, properties) {
    this.track(event, properties);
  }
  trackAsBeacon(event, properties) {
    if (this.trackerAsBeacon) {
      this.trackerAsBeacon.track(event, properties);
    }
  }
}
const Tracker = new UsageTracker();
export default Tracker;